import { connect } from 'react-redux'
import { IStore } from '../../../../../reducers'
import { isSyncing } from '../../../../../reducers/synchronize/selectors/lastSync'
import { IDeveloperToolsProps } from './DeveloperTools'

function mapStateToProps() {
  return (state: IStore): IDeveloperToolsProps => ({
    isSyncing: isSyncing(state),
  })
}

export default connect(mapStateToProps())
